import React, { Component } from 'react';
import { VDSTransmissionCancellationForm } from '../../forms';
import { Alert, Spin } from 'antd';
import {
  generateTransmissionCancellationRequestToVDSXML,
  parseResponse,
} from '../../utils/vdsHelpers';
import { sendTransmissionCancellationRequestToVDS } from '../../actions/actionHelpers/endpoints';

export class VDSTransmissionCancellationView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: '',
      request: '',
      response: null,
    };
  }

  clearMessages = () => {
    this.setState({ error: '', request: '', response: null });
  };

  send = async (values) => {
    this.clearMessages();
    values.CancelTimeProcessed = values.CancelTime.toISOString().slice(0, 19);
    const xml = generateTransmissionCancellationRequestToVDSXML(values);
    this.setState({ loading: true, request: xml, response: null });
    try {
      const responseObject = await sendTransmissionCancellationRequestToVDS({
        xml,
      });
      const response = parseResponse(responseObject);
      this.setState({
        loading: false,
        error: response.error ? 'Viga andmete saatmisel VDS-i' : '',
        response,
      });
    } catch (error) {
      console.error(error);
      const response = { error: error.message };
      this.setState({
        loading: false,
        error: 'Viga andmete saatmisel VDS-i',
        response,
      });
    }
  };

  render() {
    const { loading, error, response, request } = this.state;

    return (
      <Spin spinning={loading}>
        <h1>{'Ostu-müügitehingu (ülekande) täielik tühistamine'}</h1>
        <VDSTransmissionCancellationForm
          onSubmit={this.send}
          request={request}
          response={response}
          onReset={this.clearMessages}
        >
          {!error && !!response && (
            <Alert message={'Andmed saadeti VDS-ile'} type="success" closable />
          )}
          {!!error && <Alert message={error} type="error" closable />}
        </VDSTransmissionCancellationForm>
      </Spin>
    );
  }
}

export default VDSTransmissionCancellationView;
